// extracted by mini-css-extract-plugin
export var columnOne = "ActionItem-module--columnOne---ZrkY";
export var columnTwo = "ActionItem-module--columnTwo--Pkvdn";
export var columnZero = "ActionItem-module--columnZero--s9UQK";
export var container = "ActionItem-module--container--8TYmi";
export var name = "ActionItem-module--name--h3lsD";
export var status = "ActionItem-module--status--Z7Wge";
export var text = "ActionItem-module--text--q6QGs";
export var time = "ActionItem-module--time--O21Oi";